import rawJsApi from '@tencent/tvf-jsapi';

let jsApi = rawJsApi;
if (rawJsApi?.env?.app === 'browser') {
  jsApi = {
    on: (key, func) => {
      console.log(key, func);
    },
    invoke: async (key) => {
      console.log(key);
    },
  };
}
const JsApi = jsApi;

export default JsApi;
